import * as React from "react";

export const IconFileExport = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_31120_41112)">
        <path
          d="M11.6667 2.16602L4.99999 2.16602C4.08333 2.16602 3.34166 2.91602 3.34166 3.83268L3.33333 17.166C3.33333 18.0827 4.07499 18.8327 4.99166 18.8327L15 18.8327C15.9167 18.8327 16.6667 18.0827 16.6667 17.166V7.16602L11.6667 2.16602ZM15 17.166H4.99999L4.99999 3.83268L10.8333 3.83268V7.99935L15 7.99935V17.166ZM6.66666 13.0077L7.84166 14.1827L9.16666 12.866L9.16666 16.3327H10.8333L10.8333 12.866L12.1583 14.191L13.3333 13.0077L10.0083 9.66602L6.66666 13.0077Z"
          fill="#48A0B2"
        />
      </g>
      <defs>
        <clipPath id="clip0_31120_41112">
          <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
